/** Unknown intent counts wait for real per-image pending events; never invent slots. */
export function intentPlaceholderCount(event:{openCanvas?:boolean;adCount?:number}):number {
 return event.openCanvas === true && Number.isSafeInteger(event.adCount) && event.adCount! > 0 ? event.adCount! : 0;
}
/** Durable terminal ownership only. A child playbook's isDone can precede other children. */
export function reconcileTerminalIntentPlaceholders<T extends {taskId:string;batchId?:string}>(placeholders:Record<string,T>,messages:import('./canvas-types').CanvasChatMessage[]):Record<string,T> {
 const terminalOwners=new Set(messages.filter(message=>{
   const jobs=message.playbookJobs;
   if(jobs?.length) return jobs.every(job=>['completed','failed','cancelled'].includes(job.status));
   return ['completed','cancelled','error'].includes(message.workflowState?.status ?? '');
 }).map(message=>message.id));
 let next=placeholders;
 for(const [key,placeholder] of Object.entries(placeholders)) {
   if(placeholder.taskId.startsWith('intent-ph-') && placeholder.batchId && terminalOwners.has(placeholder.batchId)) {
     if(next===placeholders) next={...placeholders};
     delete next[key];
   }
 }
 return next;
}
